var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "HalfBulbButton",

    getDefaultProps () {
        return {"width":"48px","height":"48px","viewBox":"0 0 48 48","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>half_bulb_button</title>
  <desc>Created with Sketch.</desc>
  <defs/>
  <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="half_bulb_button" fill="#034C8C">
      <path d="M18.858518,21 C18.8576024,20.9600626 18.8571429,20.9200603 18.8571429,20.88 C18.8571429,18.0096 21.1611429,15.68 24,15.68 C26.8388571,15.68 29.1428571,18.0096 29.1428571,20.88 C29.1428571,20.9200603 29.1423976,20.9600626 29.141482,21 L18.858518,21 Z M0,24 C0,10.745166 10.7422516,0 24,0 C37.254834,0 48,10.7422516 48,24 C48,37.254834 37.2577484,48 24,48 C10.745166,48 0,37.2577484 0,24 Z M20.9142857,33.36 C20.9142857,33.932 21.3771429,34.4 21.9428571,34.4 L26.0571429,34.4 C26.6228571,34.4 27.0857143,33.932 27.0857143,33.36 L27.0857143,32.32 L20.9142857,32.32 L20.9142857,33.36 Z M24,13.6 C20.0297143,13.6 16.8,16.8656 16.8,20.88 C16.8,23.3552 18.024,25.5288 19.8857143,26.8496 L19.8857143,29.2 C19.8857143,29.772 20.3485714,30.24 20.9142857,30.24 L27.0857143,30.24 C27.6514286,30.24 28.1142857,29.772 28.1142857,29.2 L28.1142857,26.8496 C29.976,25.5288 31.2,23.3552 31.2,20.88 C31.2,16.8656 27.9702857,13.6 24,13.6 Z" id="Combined-Shape"/>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/images/half_bulb_button.svg